import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { Table, TableBody } from 'Components/Table';
import { TableHead } from 'Containers/Table';
import { PurpleButton } from 'Components/Button';

import { InletOutletRows } from 'Components/RocketDry';

import { InternalAtmosphericLogGroup } from 'Containers/RocketDry/types';

import classes from './internalAtmosphericTable.module.css';

interface Props {
  headers: any[];
  logs: InternalAtmosphericLogGroup[];
  roomAreaName: string;
  handleViewPicture: (e: any) => void;
  handleAddLog: (e: any) => void;
  handleEdit: (e: any) => void;
  handleDelete: (e: any) => void;
}

function InternalAtmosphericTable({
  headers,
  logs,
  roomAreaName,
  handleViewPicture,
  handleAddLog,
  handleEdit,
  handleDelete,
}: Props) {
  return (
    <div className={classes.tableBase}>
      {roomAreaName !== 'null' && <div className={classes.roomAreaHeader}>{roomAreaName}</div>}
      <Table className="table w-100">
        <TableHead headers={headers} sortBy="date" onClickSort={() => {}} />
        {logs?.length > 0 && (
          <TableBody>
            {logs.map((logGroup: InternalAtmosphericLogGroup) => (
              <InletOutletRows
                key={logGroup.inlet.id}
                logGroup={logGroup}
                handleViewPicture={handleViewPicture}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            ))}
          </TableBody>
        )}
      </Table>
      {/* No log placeholder handled by the room container */}
      <PurpleButton onClick={handleAddLog}>Record new visit</PurpleButton>
    </div>
  );
}

const InternalAtmosphericTableMemo = memo(InternalAtmosphericTable, areEqual);

export { InternalAtmosphericTableMemo as InternalAtmosphericTable };
